import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import React from 'react'
import Link from 'components/Link'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { isOnlyInterestedInNutritionProfileSelect } from 'modules/profile/redux/selectors/getInterestFocus/index.js'

export function GymaholicLogoLink () {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const isInterestedInNutrition = useSelector(isOnlyInterestedInNutritionProfileSelect)

  const url = isInterestedInNutrition
    ? '/track-calories'
    : '/'
  return (
    <Link
      to={url}
      title='Gymaholic Home'
      style={{
        height: isSmallScreen
          ? '100%'
          : '27px'
      }}
    >
      <GymaholicLogo />
    </Link>
  )
}

export default function GymaholicLogo ({
  width = '120',
  height = '27'
}) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  if (isSmallScreen) {
    width = '110px'
    height = '100%'
  }
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 160 27'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.27752 11.6364H11.9426V19.7512C11.9426 23.8852 9.95216 26.1818 5.97129 26.1818C1.99043 26.1818 0 23.8852 0 19.7512V6.43062C0 2.29665 1.99043 0 5.97129 0C9.95216 0 11.9426 2.29665 11.9426 6.43062V8.88038H8.11483V6.1244C8.11483 4.28708 7.34928 3.52153 5.97129 3.52153C4.74641 3.52153 3.82775 4.28708 3.82775 6.1244V20.0574C3.82775 21.8947 4.5933 22.5072 5.97129 22.5072C7.19617 22.5072 8.11483 21.8947 8.11483 20.0574V15.311H6.27752C6.27752 15.311 6.27752 11.6364 6.27752 11.6364ZM22.201 17.4545L17.1483 0.306218H21.4354L24.4976 12.0957L27.5598 0.306218H31.3876L26.3349 17.4545V26.0287H22.201V17.4545ZM45.7799 18.5263L48.5359 0.306218H54.201V26.0287H50.3732V7.6555L47.6172 26.0287H43.9426L41.0335 7.80861V26.0287H37.512V0.306218H43.177L45.7799 18.5263ZM74.7177 26.0287H70.5837L69.8182 21.4354H64.9187L64.1531 26.0287H60.6316L64.6124 0.306218H70.5837L74.7177 26.0287ZM65.5311 17.9139H69.3588L67.5215 4.89952L65.5311 17.9139ZM84.9761 26.0287H80.9952V0.306218H84.9761V11.3301H89.5694V0.306218H93.7034V26.0287H89.5694V15.0048H84.9761V26.0287ZM100.746 6.43062C100.746 2.29665 102.89 0 106.871 0C110.852 0 112.995 2.29665 112.995 6.43062V19.7512C112.995 23.8852 110.852 26.1818 106.871 26.1818C102.89 26.1818 100.746 23.8852 100.746 19.7512V6.43062ZM104.727 20.0574C104.727 21.8947 105.493 22.6603 106.871 22.6603C108.096 22.6603 109.014 21.8947 109.014 20.0574V6.1244C109.014 4.28708 108.249 3.52153 106.871 3.52153C105.646 3.52153 104.727 4.28708 104.727 6.1244V20.0574ZM119.885 0.306218H123.866V22.3541H130.45V26.0287H119.732L119.885 0.306218ZM136.727 0.306218H140.708V26.0287H136.727V0.306218ZM160 16.3828V19.7512C160 23.8852 158.01 26.1818 154.029 26.1818C150.048 26.1818 148.057 23.8852 148.057 19.7512V6.43062C148.057 2.29665 150.048 0 154.029 0C158.01 0 160 2.29665 160 6.43062V8.88038H156.172V6.1244C156.172 4.28708 155.407 3.52153 154.029 3.52153C152.804 3.52153 151.885 4.28708 151.885 6.1244V20.0574C151.885 21.8947 152.651 22.5072 154.029 22.5072C155.254 22.5072 156.172 21.8947 156.172 20.0574V16.3828H160Z'
        fill='black'
      />
    </svg>
  )
}
